module.exports = __webpack_public_path__ + "img/DSC_1836.716d43b3.JPG";